import { forwardRef, createElement } from 'react';

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2 = /*#__PURE__*/createElement("path", {
  d: "M481.082 123.718V72.825c0-11.757-9.531-21.287-21.287-21.287H36c-11.756 0-21.287 9.53-21.287 21.287v50.893h466.369z",
  fill: "#DAE8E8"
});

var _ref3 = /*#__PURE__*/createElement("path", {
  d: "M481.082 138.431H14.713C6.587 138.431 0 131.843 0 123.718V72.825c0-19.85 16.151-36 36-36h423.793c19.851 0 36 16.151 36 36v50.894c.002 8.125-6.585 14.712-14.711 14.712zM29.426 109.005h436.942v-36.18a6.581 6.581 0 00-6.574-6.574H36a6.581 6.581 0 00-6.574 6.574v36.18zM144.238 282.415H74.93c-8.126 0-14.713-6.589-14.713-14.713v-61.765c0-8.125 6.587-14.713 14.713-14.713h69.308c8.126 0 14.713 6.589 14.713 14.713 0 8.125-6.587 14.713-14.713 14.713H89.643v32.338h54.595c8.126 0 14.713 6.589 14.713 14.713 0 8.124-6.587 14.714-14.713 14.714z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/createElement("path", {
  d: "M282.552 205.94h-69.314v61.765h69.314V205.94z",
  fill: "#DAE8E8"
});

var _ref5 = /*#__PURE__*/createElement("path", {
  d: "M282.552 282.415h-69.308c-8.126 0-14.713-6.589-14.713-14.713v-61.765c0-8.125 6.587-14.713 14.713-14.713h69.308c8.126 0 14.713 6.589 14.713 14.713v61.765c0 8.124-6.587 14.713-14.713 14.713zm-54.595-29.427h39.882V220.65h-39.882v32.338zM144.238 406.06H74.93c-8.126 0-14.713-6.589-14.713-14.713v-61.765c0-8.125 6.587-14.713 14.713-14.713h69.308c8.126 0 14.713 6.589 14.713 14.713 0 8.124-6.587 14.713-14.713 14.713H89.643v32.338h54.595c8.126 0 14.713 6.589 14.713 14.713 0 8.124-6.587 14.714-14.713 14.714z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/createElement("path", {
  d: "M282.552 329.575h-69.314v61.765h69.314v-61.765z",
  fill: "#DAE8E8"
});

var _ref7 = /*#__PURE__*/createElement("path", {
  d: "M282.552 406.06h-69.308c-8.126 0-14.713-6.589-14.713-14.713v-61.765c0-8.125 6.587-14.713 14.713-14.713h69.308c8.126 0 14.713 6.589 14.713 14.713v61.765c0 8.124-6.587 14.713-14.713 14.713zm-54.595-29.427h39.882v-32.338h-39.882v32.338z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/createElement("path", {
  d: "M420.871 205.94h-69.314v61.765h69.314V205.94z",
  fill: "#DAE8E8"
});

var _ref9 = /*#__PURE__*/createElement("path", {
  d: "M420.864 282.415h-69.308c-8.126 0-14.713-6.589-14.713-14.713v-61.765c0-8.125 6.587-14.713 14.713-14.713h69.308c8.126 0 14.713 6.589 14.713 14.713v61.765c0 8.124-6.587 14.713-14.713 14.713zm-54.595-29.427h39.882V220.65h-39.882v32.338zM99.532 92.878c-8.126 0-14.713-6.589-14.713-14.713V22.06c0-8.125 6.587-14.713 14.713-14.713s14.713 6.589 14.713 14.713v56.106c0 8.125-6.587 14.712-14.713 14.712zM247.897 92.878c-8.126 0-14.713-6.589-14.713-14.713V22.06c0-8.125 6.587-14.713 14.713-14.713s14.713 6.589 14.713 14.713v56.106c0 8.125-6.587 14.712-14.713 14.712zM396.263 92.878c-8.126 0-14.713-6.589-14.713-14.713V22.06c0-8.125 6.587-14.713 14.713-14.713s14.713 6.589 14.713 14.713v56.106c0 8.125-6.587 14.712-14.713 14.712z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/createElement("path", {
  d: "M389.88 504.653c-67.338 0-122.12-54.782-122.12-122.12 0-67.338 54.782-122.12 122.12-122.12 36.752 0 71.2 16.321 94.512 44.78 5.15 6.285 4.229 15.556-2.058 20.706-6.285 5.148-15.556 4.229-20.706-2.058-17.7-21.608-43.851-33.999-71.747-33.999-51.111 0-92.693 41.582-92.693 92.693s41.582 92.693 92.693 92.693 92.693-41.582 92.693-92.693c0-8.125 6.587-14.713 14.713-14.713S512 374.411 512 382.535c0 67.335-54.782 122.118-122.12 122.118z",
  fill: "currentColor"
});

var _ref11 = /*#__PURE__*/createElement("path", {
  d: "M228.475 490.606H36c-19.85 0-36-16.151-36-36V72.825c0-19.85 16.151-36 36-36h423.793c19.851 0 36 16.151 36 36v164.701c0 8.125-6.587 14.713-14.713 14.713s-14.713-6.589-14.713-14.713V72.825a6.581 6.581 0 00-6.574-6.574H36a6.581 6.581 0 00-6.574 6.574v381.781A6.581 6.581 0 0036 461.18h192.474c8.126 0 14.713 6.589 14.713 14.713 0 8.125-6.586 14.713-14.712 14.713z",
  fill: "currentColor"
});

var _ref12 = /*#__PURE__*/createElement("path", {
  d: "M429.606 382.533H389.88v-39.725",
  fill: "#FDFEFE"
});

var _ref13 = /*#__PURE__*/createElement("path", {
  d: "M429.606 397.247H389.88c-8.126 0-14.713-6.589-14.713-14.713v-39.726c0-8.125 6.587-14.713 14.713-14.713s14.713 6.589 14.713 14.713v25.012h25.012c8.126 0 14.713 6.589 14.713 14.713 0 8.124-6.586 14.714-14.712 14.714z",
  fill: "currentColor"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=calendar.svg.js.map
